import { useEffect, useState } from "react";
import config from "../config";

// Component to handle config loading
export const useConfigLoader = (store) => {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const configResponse = await fetch("/config_env.json").then((response) => response.json());
        const useSscIamPreProd =
          (window.localStorage.getItem("useSscIamPreProd") ?? "") === "" ||
          (window.localStorage.getItem("useSscIamPreProd") ?? "true") === "true";

        store.dispatch(
          config.actions.set({
            environment: configResponse.ENVIRONMENT,
            backofficeHost: configResponse.BACKOFFICE_HOST,
            loginHost: configResponse.LOGIN_HOST,
            apiHost: configResponse.API_HOST,
            gitHead: configResponse.GIT_HEAD,
            packageVersion: configResponse.PACKAGE_VERSION,
            mixpanelToken: configResponse.MIXPANEL_TOKEN,
            backofficeClientId: configResponse.BACKOFFICE_CLIENT_ID,
            supportalHost: config.SUPPORTAL_HOST,
            cognitoUserPoolId: configResponse.COGNITO_USER_POOL_ID,
            cognitoMerchantPortalClientId: configResponse.COGNITO_MERCHANT_PORTAL_CLIENT_ID,
            cognitoSupportalClientId: configResponse.COGNITO_SUPPORTAL_CLIENT_ID,
            dxGateway: configResponse.DX_GATEWAY,
            oidcProvider: useSscIamPreProd
              ? configResponse.OIDC_PROVIDER
              : "https://auth.ssciam.sandbox.worldline-solutions.com/authflow/v1/tenants/ms1",
            sscIamClientId: useSscIamPreProd ? configResponse.SSC_IAM_CLIENT_ID : "bambora-supportal-test",
            sscIamUserMgtApi: useSscIamPreProd
              ? configResponse.SSC_IAM_USER_MANAGER_API
              : "https://auth.ssciam.sandbox.worldline-solutions.com/authflow/v1/tenants/ms1",
            portal2Host: configResponse.PORTAL2_BE_HOST,
          })
        );

        setConfigLoaded(true);
      } catch (error) {
        console.error("Error loading config:", error);
      }
    };

    loadConfig();
  }, []);

  return configLoaded;
};
